import type { VignetteDefinition } from "./types";

/**
 * A common, reflective activity — Johnny gazing out at the open water,
 * watching for passing ships (the original concept's telescope activity,
 * without an actual telescope prop yet). Uses "Idle_Neutral", a calmer
 * idle variant from the sourced library, distinct from his default Idle.
 */
export const watchingHorizonVignette: VignetteDefinition = {
  id: "watching-horizon",
  name: "Watching the horizon",
  category: "common",
  weight: 7,
  animationClip: "Idle_Neutral",
  loopAnimation: true,
  durationMs: 6000,
  cameraFraming: {
    // Aimed directly at Johnny (matching the pattern that actually works
    // elsewhere — see jogging/diving) rather than out toward the ocean: an
    // earlier version pointed offset and targetOffset at two *close, almost
    // parallel* points, putting the camera nearly edge-on to the sand
    // plane and filling the frame with a close-up of sand meeting sky.
    // Positioning the camera itself out toward the water is what actually
    // sells "watching the ocean," not where the look-at target points.
    offset: { x: -3.5, y: 1.6, z: 3.0 },
    targetOffset: { x: 0, y: 1, z: 0 },
  },
  audioCues: [],
  timeOfDay: "any",
};
